import { postCoverImage } from 'apiCalls/PhotographerRequests'
import { SpinLoader } from 'components/Loader/SpinLoader'
import { profilePageIcons } from 'components/admin/Images'
import Compressor from 'compressorjs'
import { useAppContext } from 'context/AppContext'
import PropTypes from 'prop-types'
import React, { useRef, useState, useCallback } from 'react'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import styled, { css } from 'styled-components'
const { CameraIcon } = profilePageIcons

function CoverImageUpload(props) {
  const { loading, setLoading } = props
  const [uploadedFile, setUploadedFile] = useState()
  const [context, dispatch] = useAppContext()
  const imageRef = useRef(null)
  // const [loading, setLoading] = useState(false)
  const [lightboxOpen, setLightboxOpen] = useState(false)
  const [crop, setCrop] = useState({
    aspect: 2.5 / 1,
    width: window.innerWidth * 0.4,
    height: (window.innerWidth * 0.4) / 2.5,
  })

  const [cropSave, setCropSave] = useState(0)
  const cropImgRef = useRef(null)
  const previewCanvasRef = useRef(null)
  const [imageInfo, setImageInfo] = useState()

  const onChange = (e) => {
    let result = e.target.files[0]
    if (result) {
      let newFile = new File([result], result.name)
      setUploadedFile(URL.createObjectURL(newFile))
      setLightboxOpen(true)
      setImageInfo(e.target.files[0])
    } else {
      dispatch({
        type: 'setAlertType',
        alertType: 'error',
      })
      dispatch({
        type: 'setAlertText',
        alertText: ['Image format is not supported '],
      })
    }
  }

  // GET CROPPED IMAGE FILE BEFORE TO SUBMIT
  const submitCroppedImg = () => {
    if (cropSave > 1 && previewCanvasRef.current) {
      const image = cropImgRef.current
      const canvas = previewCanvasRef.current
      const pixelRatio = window.devicePixelRatio
      const scaleX = image.naturalWidth / image.width
      const scaleY = image.naturalHeight / image.height
      const ctx = canvas.getContext('2d')

      canvas.width = crop.width * pixelRatio * scaleX
      canvas.height = crop.height * pixelRatio * scaleY

      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
      ctx.imageSmoothingQuality = 'high'

      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width * scaleX,
        crop.height * scaleY,
      )

      return new Promise((resolve, reject) => {
        previewCanvasRef.current.toBlob(
          (blob) => {
            if (!blob) {
              //reject(new Error('Canvas is empty'));
              console.error('Canvas is empty')
              return
            }
            // ENSURE CROPPED IMAGE IS 2000PX WIDTH
            blob.name = imageInfo.name
            new Compressor(blob, {
              maxWidth: 2000,
              success(result) {
                let newFile = new File([result], result.name)
                setUploadedFile(URL.createObjectURL(newFile))
                setLightboxOpen(false)
                onSubmit(newFile)
              },
            })

            resolve(blob)
          },
          'image/jpeg',
          1,
        )
      })
    }
  }

  //  SET REFERENCE TO LOADED IMAGE
  const onLoad = useCallback((img) => {
    cropImgRef.current = img
  }, [])

  async function onSubmit(file) {
    setCropSave(0)
    setLoading(true)
    const formData = new FormData()
    formData.append('image', file)
    const response = await postCoverImage(formData, context.photographer.identifier, context.token)
    if (response.status === 201) {
      props.uploaded(true)
      setLightboxOpen(false)
      dispatch({
        type: 'setPhotographer',
        photographer: {
          ...context.photographer,
          coverImage: [response.data],
        },
      })
      dispatch({
        type: 'setAlertType',
        alertType: 'success',
      })
      dispatch({
        type: 'setAlertText',
        alertText: ['Changes were successfully saved'],
      })
    } else {
      dispatch({
        type: 'setAlertType',
        alertType: 'error',
      })
      dispatch({
        type: 'setAlertText',
        alertText: ['Changes were unsuccessful'],
      })
      throw new Error(response.data)
    }
    setLoading(false)
  }

  const handleImageButton = () => {
    imageRef.current.click()
  }

  return (
    <React.Fragment>
      <Input
        ref={imageRef}
        type="file"
        id="customFile"
        className="form-control"
        data-testid={props.testid}
        style={{ display: 'none', fontSize: '16px' }}
        onChange={onChange}
        accept="image/png, image/jpeg, image/jpg"
      />
      {!loading &&
        (props.hideImage ? (
          // <Button onClick={handleImageButton}>Select Image</Button>
          <UploadProfileIcon onClick={handleImageButton} src={CameraIcon} alt="upload-cover" />
        ) : (
          <Col>
            {!loading ? (
              <ImgWrapper $round={props.round ? true : false} $header={props.header ? true : false}>
                <Img src={uploadedFile || props.image} alt="cover image upload" />
              </ImgWrapper>
            ) : (
              <AvtarLoader>
                <SpinLoader size={50} />{' '}
              </AvtarLoader>
            )}
            <ButtonWrapper>
              <Button onClick={handleImageButton}>Select Image</Button>
            </ButtonWrapper>
          </Col>
        ))}
      {lightboxOpen && (
        <LightBox>
          <Wrap>
            <ConfirmRow>
              <CloseButton
                id="close-cover-image-crop"
                onClick={() => {
                  setLightboxOpen(false)
                }}
              >
                <CloseSpan1 />
                <CloseSpan2 />
              </CloseButton>
              <ConfirmButton data-cy="cover-image-upload-confirm" onClick={() => submitCroppedImg()}>
                Confirm
              </ConfirmButton>
            </ConfirmRow>
            <ReactCrop
              className="react-crop"
              style={{ overflowY: 'scroll', maxHeight: '90vh' }}
              maxWidth={window.innerWidth > 500 ? window.innerWidth * 0.72 : window.innerWidth * 0.96}
              src={uploadedFile}
              crop={crop}
              onChange={(newCrop) => {
                setCrop(newCrop)
                setCropSave(cropSave + 1)
              }}
              onImageLoaded={onLoad}
            />
            <Canvas ref={previewCanvasRef} />
          </Wrap>
        </LightBox>
      )}
    </React.Fragment>
  )
}

export default CoverImageUpload

CoverImageUpload.propTypes = {
  image: PropTypes.string.isRequired,
  round: PropTypes.bool,
}

const Col = styled.div`
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  position: relative;
  width: 100%;
  min-height: 1px;
  padding: 0 15px;
`
const ButtonWrapper = styled.div`
  display: block;
  text-align: center !important;
`

const Button = styled.button`
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  text-transform: none;
  transition: all 0.15s ease;
  letter-spacing: 0.025em;
  will-change: transform;
  margin: 1em 0 0.5em 0;
  font-size: 12px;
  background-color: var(--black);
  padding: 0.25rem 0.75rem;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);

  :hover {
    box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
  }

  @media (min-width: 769px) {
    margin-bottom: auto;
  }
`
const Input = styled.input``

const AvtarLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const ImgWrapper = styled.div`
  display: flex !important;
  align-self: center !important;
  margin: 0 auto !important;
  color: #fff;
  background-color: #adb5bd;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  overflow: hidden;
  width: 100%;
  border-radius: ${(props) => (props.$round ? '50%!important;' : '0.375rem')};

  ${(props) =>
    props.$header &&
    css`
      width: 500px;
    `}
`

const Img = styled.img`
  display: flex;
  align-items: flex-start;
  justify-content: center !important;
  width: 100%;
`

const LightBox = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Canvas = styled.canvas`
  display: none;
`

const ConfirmButton = styled.button`
  padding: 0 1.2em;
  font-size: 14px;
  letter-spacing: 1px;
  color: #fff;
  background-color: var(--forward);
  border: 1px solid var(--dark-yellow);
  :hover {
    opacity: 0.9;
  }
  @media (max-width: 700px) {
    padding: 0 0.8em;
    font-size: 12px;
  }
`

const CloseButton = styled.button`
  font-size: 1.2em;
  background-color: initial;
  border: 1px solid transparent;
  border-color: transparent;
  padding: 0 15px;
  flex: 0 0 50%;
  text-align: right;
  @media (max-width: 992px) {
    width: 20px;
    height: 20px;
    position: relative;
    cursor: pointer;
  }
  :hover {
    color: var(--light-yellow);
  }
`

const CloseSpan1 = styled.span`
  position: absolute;
  width: 16px;
  height: 2px;
  border-radius: 2px;
  background: #fff;
  transform: rotate(135deg);
  left: 0%;
`

const CloseSpan2 = styled(CloseSpan1)`
  transform: rotate(-135deg);
`

const Wrap = styled.div`
  max-height: 100vh;
  max-width: 72vw;
  @media (max-width: 1100px) {
    max-width: 82vw;
  }
  @media (max-width: 900px) {
    max-width: 85vw;
  }
  @media (max-width: 700px) {
    max-width: 90vw;
  }
  @media (max-width: 500px) {
    max-width: 96vw;
  }
`

const ConfirmRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 10px 0;
`
const UploadProfileIcon = styled.img`
  cursor: pointer;
  width: 3rem;
  position: absolute;
  top: 2.5em;
  left: 3.5em;
`
